import React from "react";
import { useHistory } from "react-router-dom";
import ShowAll from "./components/ShowAll/ShowAll";
import YhButton from "../../ui/YhButton";
import urls from "../../global/constants/UrlConstants";
import { store } from "../../utils/store";

interface CustomProps {
  setToggle: any;
  toggle: any;
}

const Project = (_props: CustomProps) => {
  const history = useHistory();
  const privileges = store.getState().auth?.privileges || {};
  const canCreate =
    privileges?.["Project List"]?.includes("create") ||
    privileges?.["Project List"]?.includes("full control");

  return (
    <div className="flex h-[calc(100vh-68px)] max-h-[calc(100vh-68px)] flex-col overflow-hidden bg-white p-4 sm:p-5 lg:p-6">
      <div className="mb-4 flex shrink-0 flex-wrap items-start justify-between gap-3">
        <div>
          <h1 className="text-2xl font-bold tracking-tight text-[#111827]">
            Project List
          </h1>
          <p className="mt-1 text-sm text-[#6B7280]">
            Manage your project here.
          </p>
        </div>
        {canCreate ? (
          <YhButton
            variant="primary"
            size="md"
            onClick={() => history.push(urls.CREATEPROJECT)}
          >
            Add New
          </YhButton>
        ) : null}
      </div>
      <div className="min-h-0 flex-1 overflow-auto">
        <ShowAll type={"all"} />
      </div>
    </div>
  );
};

export default Project;
